module.exports = __webpack_public_path__ + "static/media/grabpay-image.69dd6323.png";